import template from "./quote-header-modal.html";
import padStart from "lodash/padStart";
import { ACCEPTOR, VIEWER } from "../../../config/quote-roles";

const QuoteHeaderModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },

  template: template,

  controller: class QuoteHeaderModalController {
    /* @ngInject */
    constructor(
      $rootScope,
      $scope,
      $filter,
      Quote,
      SmartVault,
      ModalsManager,
      Contact,
      SecurityManager,
      Notification
    ) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$filter = $filter;
      this.Quote = Quote;
      this.SmartVault = SmartVault;
      this.ModalsManager = ModalsManager;
      this.Contact = Contact;
      this.SecurityManager = SecurityManager;
      this.NotificationService = Notification;
    }

    async $onInit() {
      const defaultQuoteNumber =
        this.$rootScope.organization.getDefaultQuoteNumber();
      this.quoteNumberPrefix = defaultQuoteNumber.prefix;
      this.quoteNumber = Number(defaultQuoteNumber.nextNumber);
      this.originalValue = Number(defaultQuoteNumber.nextNumber);
      this.openedMoreData = false;
      this.prospectiveClient = false;
      this.openedAdditionalContacts = false;
      this.additionalContacts = 1;
      this.errorCodeIsNotUnique = false;
      this.quoteNumbers = this.$rootScope.organization.settings.quoteNumbers;
      this.quote = null;
      this.isEdit = this.resolve.params.edit;
      this.saving = false;
      this.contacts = [];
      this.clients = [];
      this.mainContactEmail = null;
      this.contactsApproved = {};
      this.filteredContacts = [];
      this.organization = this.$rootScope.organization;
      this.quoteRoles = [ACCEPTOR, VIEWER];
      this.invalidCharacters = '[^\\/*?:"<>|%#+]+';
      this.emailPattern = "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";

      if (this.isEdit) {
        this.quote = this.resolve.params.quote;
        this.prospectiveClient = this.quote.client.isProspective;
        this.additionalContacts = this.quote.quoteContacts.length - 1;
        this.openedAdditionalContacts = this.quote.quoteContacts.length > 1;
        if (!this.quote.client.isProspective) {
          this.clients = [this.quote.client];
          await this.getContacts();
          if (this.quote.contact) {
            this.mainContactEmail = this.quote.contact.email;
          }
        }
        this.checkContactsHaveApproved();
      } else {
        this.template = null;
        this.quoteToClone = null;
        this.quote = new this.Quote();

        const { cid } = this.resolve.params;
        if (cid) {
          await this.selectDefaultClient(cid);
        }

        if (
          this.resolve.params &&
          this.resolve.params.template &&
          this.resolve.params.name
        ) {
          this.isDefaultTemplate = this.resolve.params.isDefaultTemplate;
          this.isImportedTemplate = this.resolve.params.isImportedTemplate;
          this.quote.description = this.resolve.params.name;
          this.quote.language = this.resolve.params.language;
          this.quote.lastVersion.currency = this.resolve.params.currency;
          this.template = this.resolve.params.template;
        }

        if (this.resolve.params && this.resolve.params.quoteToClone) {
          this.quoteToClone = this.resolve.params.quoteToClone;
          this.quote.description = this.resolve.params.name;
          this.quote.language = this.resolve.params.language;
          this.quote.lastVersion.currency = this.resolve.params.currency;

          const prefix = this.resolve.params.prefix;
          this.quoteNumberPrefix = prefix || "";
          if (prefix) {
            if (
              this.quoteNumbers.some(
                (quoteNumber) => quoteNumber.prefix === prefix
              )
            ) {
              this.quoteNumbers.forEach((quoteNumber) => {
                if (quoteNumber.prefix === prefix)
                  this.quoteNumber = Number(quoteNumber.nextNumber);
                this.originalValue = Number(quoteNumber.nextNumber);
              });
            } else {
              this.quoteNumber = 1;
              this.originalValue = 1;
            }
          } else {
            this.quoteNumbers.forEach((quoteNumber) => {
              if (!quoteNumber.prefix) {
                this.quoteNumber = Number(quoteNumber.nextNumber);
                this.originalValue = Number(quoteNumber.nextNumber);
              }
            });
          }
        }

        this.setCurrency(this.organization.settings.currency);
      }

      this.$scope.$watch(
        () => this.quoteNumberPrefix,
        (newValue, oldValue) => {
          if (!angular.equals(newValue, oldValue)) {
            if (
              this.quoteNumbers.some(
                (quoteNumber) => quoteNumber.prefix === newValue
              )
            ) {
              this.quoteNumbers.forEach((quoteNumber) => {
                if (quoteNumber.prefix === newValue) {
                  this.quoteNumber = Number(quoteNumber.nextNumber);
                  this.originalValue = Number(quoteNumber.nextNumber);
                }
              });
            } else {
              this.quoteNumber = 1;
              this.originalValue = 1;
            }
          }
        }
      );

      if (!this.quote.lastVersion.currency)
        this.setCurrency(this.$rootScope.organization.settings.currency);
      this.oldCurrency = this.quote.lastVersion.currency;
    }

    close() {
      return this.dismiss({ $value: "cancel" });
    }

    showMoreData() {
      this.openedMoreData = !this.openedMoreData;
    }

    toggleAdditionalContacts() {
      this.openedAdditionalContacts = !this.openedAdditionalContacts;
      if (this.openedAdditionalContacts && !this.additionalContacts) 
      {
        this.addAdditionalContact();
      }      
    }

    addAdditionalContact() {
      this.additionalContacts++;
    }

    setCurrency(oldCurrency, newCurrency) {
      if (!newCurrency) this.quote.lastVersion.currency = oldCurrency;
      else this.quote.lastVersion.currency = newCurrency;
    }

    setLanguage(oldQuoteLanguage, newQuoteLanguage) {
      if (!newQuoteLanguage) this.quote.language = oldQuoteLanguage;
      else this.quote.language = newQuoteLanguage;
    }

    setQuoteNumber(quoteNumber) {
      this.quoteNumberPrefix = quoteNumber.prefix;
    }

    async onChangeContact(index) {
      this.quote.quoteContacts[index].role =
        this.quote.quoteContacts.length > 1 ? VIEWER : ACCEPTOR;
      this.setFilteredContacts();
      this.setMainContact();
      this.$rootScope.$applyAsync();
    }

    clearContactFormFields(index) {
      const fieldNames = ["contactEmail", "contactLastName", "contactName"];
      const form = this.form;
      fieldNames.forEach(function (fieldName) {
        const field = form[`${fieldName}${index - 1}`];
        field.$setViewValue(null);
        field.$commitViewValue();
        field.$render();
      });
    }

    async onRemoveContact(index) {
      const contact = this.quote.quoteContacts[index]?.contact;
      if (contact) {
        this.quote.quoteContacts.splice(index, 1);
        if (
          this.quote.contact?.email &&
          this.quote.contact.email === contact.email
        ) {
          this.quote.contact = null;
          this.mainContactEmail = null;
        }

        if (!this.prospectiveClient) {
          this.setFilteredContacts();
          this.setMainContact(index - 1 >= 0 ? index - 1 : 0);
        }
      }

      if (this.prospectiveClient) {
        this.additionalContacts--;
        if (!this.additionalContacts) {
          this.additionalContacts = 1;
          this.clearContactFormFields(index);
        }
      }
    }

    setMainContact(index = 0) {
      if (
        !this.quote.contact &&
        this.quote.quoteContacts &&
        this.quote.quoteContacts?.length
      ) {
        this.mainContactEmail = this.quote.quoteContacts[index].contact.email;
        this.updateMainContact(this.quote.quoteContacts[index].contact);
      }
    }

    updateMainContact(contact) {
      this.quote.contact = contact;
      this.$rootScope.$applyAsync();
    }

    setFilteredContacts(searchText) {
      this.filteredContacts = [...this.contacts].filter((contact) => {
        const foundEmail = this.quote.quoteContacts.some(
          (quoteContact) => quoteContact.contact.email === contact.email
        );
        const searched = searchText
          ? ["firstName", "middleName", "lastName", "email"].some((key) =>
              !!contact[key]
                ? this.canonize(contact[key]).includes(
                    this.canonize(searchText)
                  )
                : false
            )
          : true;
        return !foundEmail && searched;
      });

      this.$rootScope.$applyAsync();
    }

    toggleSignatureToAccept() {
      if (
        this.quote.lastVersion.signature &&
        this.quote.lastVersion.signature.requiredToAccept
      ) {
        this.quote.lastVersion.signature.requiredToAccept = false;
        this.quote.lastVersion.signature.snapshot = undefined;
      } else {
        this.quote.lastVersion.signature = {
          requiredToAccept: true,
          snapshot: this.$rootScope.organization.settings.signature,
        };
      }
    }

    toggleEmailToCustomerOnAccept() {
      this.quote.emailToCustomerOnAccept = !this.quote.emailToCustomerOnAccept;
    }

    togglePdfDownloadable() {
      this.quote.pdfDownloadable = !this.quote.pdfDownloadable;
    }

    toggleApproveFromPublicView() {
      this.quote.approveFromPublicView = !this.quote.approveFromPublicView;
    }

    async save() {
      this.prospectiveClient &&
        (this.quote.quoteContacts = this.quote.quoteContacts.filter(
          ({ contact }) => {
            const entries = Object.values(contact);
            return entries.some((entry) => {
              return typeof entry === "string" && entry.trim() !== "";
            });
          }
        ));

      if (this._isQuoteInvalid()) {
        if (!this.openedMoreData) this.showMoreData();
        return;
      }

      this.saving = true;
      let quote;
      if (this.quote._id) {
        this.newCurrency = this.quote.lastVersion.currency;
        if (this.oldCurrency && this.oldCurrency !== this.newCurrency) {
          this.quote.lastVersion.updateCurrency(
            this.oldCurrency,
            this.newCurrency
          );
        }
        await this.quote.updateHeader();
        await this.quote.updateSections();
        quote = this.quote;
        this.saving = false;
        this.$rootScope.$applyAsync();
        this.close({ $value: quote });
      } else {
        this.quote.code =
          (this.quoteNumberPrefix || "") + padStart(this.quoteNumber, 4, "0");

        this.quote.client.isProspective = this.prospectiveClient;

        try {
          quote = await this.quote.create(
            this.template,
            this.isDefaultTemplate,
            this.isImportedTemplate,
            this.quoteToClone
          );
          await this.SecurityManager.refreshUser();
          this.saving = false;
          this.$rootScope.$applyAsync();
          this.close({ $value: quote });
        } catch (error) {
          if (
            error.status === 400 &&
            error.data === "Quote code is not unique"
          ) {
            this.errorCodeIsNotUnique = true;
            this.saving = false;
            if (!this.openedMoreData) this.showMoreData();
            this.$rootScope.$applyAsync();
          } else if (
            error.status === 500 &&
            error.data === "Contact doesn't belong to quote's client"
          ) {
            this.NotificationService.error({
              title: this.$filter("trans")("notificationService.title.ups"),
              message: this.$filter("trans")(
                "notificationService.message.contactDoesntBelongToClient"
              ),
            });
          } else {
            throw error;
          }
        } finally {
          this.saving = false;
          this.$rootScope.$applyAsync();
        }
      }
    }

    checkContactsHaveApproved() {
      this.contactsApproved = {};
      this.quote.quoteContacts.forEach((quoteContact) => {
        this.contactsApproved[quoteContact.contact.email] =
          this.quote.lastVersion.approvedBy.find(
            (approved) => quoteContact.contact.email === approved.contact.email
          );
      });
    }

    async getClients(inputValue) {
      if (!inputValue || !inputValue.length) {
        this.clients = [this.quote.client];
        this.noClientsError = false;
        this.$rootScope.$applyAsync();
        return;
      }

      this.setFilteredContacts();
      this.loadingClients = true;

      try {
        this.clients = await this.SmartVault.getAccountClients(inputValue);
        this.noClientsError = !this.clients.length;
        if (this.noClientsError) this.clients = [null];
      } catch (e) {
      } finally {
        this.loadingClients = false;
        this.$rootScope.$applyAsync();
      }
    }

    async getContacts() {
      this.contacts.length = 0;
      if (!this.quote.client) return;

      this.loadingContacts = true;
      this.setFilteredContacts();
      this.$rootScope.$applyAsync();

      try {
        this.contacts = (
          await this.SmartVault.getClientContacts(
            this.quote.client.smartVaultId
          )
        ).map((contact) => Object.assign(new this.Contact(), { ...contact }));

        this.noContactsError = !this.contacts.length
          ? `https://svportal.${process.env.SMARTVAULT_API_URL}/app/${this.organization.name}/clients/edit/?fid=${this.organization.smartVaultId}&id=${this.quote.client.smartVaultId}`
          : null;

        this.clientAccessError = false;
      } catch (e) {
        if (e.data === "Access Denied") {
          this.clientAccessError = true;
        }
      } finally {
        this.setFilteredContacts();
        this.loadingContacts = false;
        this.$rootScope.$applyAsync();
      }
    }

    async selectDefaultClient(cid) {
      this.quote.client = await this.SmartVault.getClient(cid);

      this.$rootScope.$applyAsync();
      await this.getContacts();
    }

    canonize(text) {
      return text ? text.trim().toLowerCase() : "";
    }

    isContactInClientContacts(checkContact) {
      if (!checkContact) return true;
      return (
        this.prospectiveClient ||
        this.contacts.some((contact) => contact.email === checkContact.email)
      );
    }

    toggleProspectiveClient() {
      Object.assign(this.quote, {
        client: null,
        quoteContacts: [],
        contact: null,
      });

      if (this.prospectiveClient) {
        this.quote.quoteContacts = [{ role: this.quoteRoles[0] }];
      }

      this.$rootScope.$applyAsync();
    }

    _isQuoteInvalid() {
      return (
        !this.form.$valid ||
        !this.quote.quoteContacts.length ||
        !this.quote.contact ||
        (!this.prospectiveClient &&
          this.quote.quoteContacts.some(
            ({ contact }) => !this.isContactInClientContacts(contact)
          )) ||
        (this.prospectiveClient &&
          this.quote.quoteContacts.some(
            ({ contact, role }) =>
              !contact.firstName !== !contact.lastName ||
              !contact.lastName !== !role
          ))
      );
    }
  },
};

export default QuoteHeaderModalComponent;
